// Colocated strings for BaseDonutChart (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by the SFC as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off. Only `others` lives here — the slice label the component
// invents itself; the chart's `title`/`seriesName` arrive already translated as props.
//
// Lifted verbatim from the app's `src/locales.js` — one file per locale that bundle
// actually has (10; the all-empty `defaultLocale` bundle is deliberately not copied).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
